import * as React from "react";
import Component from "../../AbstractComponent";
import TextField from "../Material/TextField";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Constants from "../../../Action/Constants";
import { PromptDialog } from "./PromptDialog";
import { PageTransition } from "../Spinner/PageTransition";
import * as uuidV4 from "uuid/v4";

export class CoachNewCounterpartyDialog extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachCreateNewCounterparty: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    amazonFolderName: uuidV4(),
    firstName: "",
    lastName: "",
    counterpartyType: "person",
    tenantFirstName: "",
    tenantLastName: "",
    companyNameTenant: "",
    company: null,
    person: null,
    showNextButton: false,
    isSaving: false,
    isClosePreprocessDialogOpen: false
  };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openCoachCreateNewCounterparty: this.props.openCoachCreateNewCounterparty,
    });
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      openCoachCreateNewCounterparty: nextProps?.openCoachCreateNewCounterparty,
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachCreateNewCounterparty: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      selectedUnit: null,
      amazonFolderName: uuidV4(),
      firstName: "",
      lastName: "",
      counterpartyType: "person",
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: "",
      company: null,
      person: null,
      showNextButton: false,
      isSaving: false,
      isClosePreprocessDialogOpen: false,
    });
  }

  public onCloseCounterpartyCoach = () => {
    this.clearBackEndErrors();
    setTimeout(() => {this.clearState()}, 100);
    
    if(this.props.onCloseCounterpartyCoach){
      this.props.onCloseCounterpartyCoach.call(this, this.state.company || this.state.person);
    }
  }


  // Steppers components content
  public renderContent = () => {
    return (
      <div>
        <RadioGroup
          className="filters-container"
          value={this.state.counterpartyType}
          onChange={this.choosecounterpartyType}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            width: "500px",
            paddingLeft: "0px"
          }}
        >
          <FormControlLabel
            control={<Radio color="primary" />}
            value="person"
            label={this.trans("coach/propertyowner-radiobutton/person")}
            style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
          />
          <FormControlLabel
            control={<Radio color="primary" />}
            value="company"
            label={this.trans("coach/propertyowner-radiobutton/company")}
            style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
          />
        </RadioGroup>
        { this.state.counterpartyType === "person" &&
          <div>
            <div style={{display: "flex", width: "100%"}}>
              <div style={{ width: "600px", marginRight: "20px"}}>
                <TextField
                  autoComplete="off"
                  // id="firstName"
                  // name="firstName"
                  className="form-element full-size scroll-to-firstName"
                  type="text"
                  autoFocus={true}
                  label={this.trans("label-first-name")}
                  value={this.state.tenantFirstName}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                  variant="standard"
                  error={!!this.getErrorFor("firstName")}
                />
              {(!!this.getErrorFor("firstName")) && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}  
              </div>  
            <TextField
              autoComplete="off"
              // id="lastName"
              // name="lastName"
              className="form-element full-size scroll-to-lastName"
              type="text"
              label={this.trans("label-last-name") + this.trans("field/optional")}
              value={this.state.tenantLastName}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
              variant="standard"
              error={!!this.getErrorFor("lastName")}
            />
          </div>
        </div>
        }
        {
          this.state.counterpartyType === "company" && 
          <div>
             <TextField
              autoComplete="off"
              className="form-element full-size"
              type="text"
              label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
              value={this.state.companyNameTenant}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyNameTenant")}
              variant="standard"
              autoFocus={true}
              error={this.getErrorFor("name")}
            />
            {!!this.getErrorFor("name") && <div className="component-error-text">{this.getErrorFor("name")}</div>}
          </div>   
        }
      </div>   
    );         
  }

  public changeTenantChoice = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantChoice: choice,
      person: null,
      firstName: "",
      showNextButton: false
    });
  }


  //Methods

  public clearTenant = (): void => {
    this.setState({
      person: null
    }, () => {
      if (!this.state.person){
        this.setState({
          showNextButton: false
        })
      }
    });
  }

  public clearPerson = (): void => {
    this.setState({
      person: null
    }, () => {
      if(!this.state.person){
        this.setState({
          showNextButton: false
        })
      }
    });
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public choosecounterpartyType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      counterpartyType: choice,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: ""
    });
  }
   
  public getPayloadTenant = (): any => {
    const pageTemplate = "person";

    return {
      person: {
        firstName: this.state.tenantFirstName,
        lastName: this.state.tenantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      }
    };
  }

  public save = () => {
    this.setState({
      errorFields: null //need for clear error for occupant fields
    }, () => {
      if(this.state.counterpartyType === "person") {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
            payload: this.getPayloadTenant(),
            onSuccess: person => {
              this.setState({
                isSaving: false,
                person: person,
                showNextButton: true,
                errorFields: null
              }, () => {
                if(!this.state.errorFields) {
                  this.onCloseCounterpartyCoach();
                } 
              });
            },
            onError: (error) => {
              this.setState({
                isSaving: false,
                errorFields: error.fields,
              });
            }
          });
        });
      } else {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
            payload: {
              company: {
                name: this.state.companyNameTenant,
                email: "",
                phone: "",
                mainBankAccountId: "",
                address: null,
                amazonFolderName: "",
                note: "",
                pageTemplate: "company"
              }
            },
            onSuccess: (company) => {
              this.setState({
                company: company,
                showNextButton: true,
                errorFields: null,
                isSaving: false
              }, () => {
                if(!this.state.errorFields) {
                  this.onCloseCounterpartyCoach();
                }
              })
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                isSaving: false
              })
            }
          });
        });
      }
    })
  }


  public render() {
    return (
      <div>
        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.openCoachCreateNewCounterparty}
          title={this.trans("coach/newcounterparty-step/first-title")}
          content={
            this.renderContent()
          }
          positiveButtonLabel={this.trans("dialog-button/save")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.save()}
          onDiscard={() => this.onCloseCounterpartyCoach()}
          innerDialogClasses="dialog-create-counterparty"
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
